/**
 * Detects the social link name based on the URL
 * @param url - The social link URL
 * @returns The detected social link name or null if not recognized
 */
export function detectSocialLinkName(url: string): string {
  if (!url) return "";

  const trimmedUrl = url.trim();

  // Check for tel: and mailto: schemes before URL parsing
  if (trimmedUrl.startsWith("tel:")) return "Phone";
  if (trimmedUrl.startsWith("mailto:")) return "Email";

  // Normalize URL - add protocol if missing
  let normalizedUrl = trimmedUrl;
  if (!normalizedUrl.match(/^https?:\/\//i)) {
    normalizedUrl = `https://${normalizedUrl}`;
  }

  try {
    const urlObj = new URL(normalizedUrl);
    const hostname = urlObj.hostname.toLowerCase();

    // Remove www. prefix if present
    const cleanHostname = hostname.replace(/^www\./, "");

    // Twitter/X
    if (
      cleanHostname.includes("twitter.com") ||
      cleanHostname.includes("x.com")
    ) {
      return "Twitter";
    }

    // Discord
    if (
      cleanHostname.includes("discord.gg") ||
      cleanHostname.includes("discord.com")
    ) {
      return "Discord";
    }

    // Telegram
    if (
      cleanHostname.includes("telegram.org") ||
      cleanHostname.includes("t.me")
    ) {
      return "Telegram";
    }

    // Instagram
    if (cleanHostname.includes("instagram.com")) {
      return "Instagram";
    }

    // Facebook
    if (cleanHostname.includes("facebook.com")) {
      return "Facebook";
    }

    // LinkedIn
    if (cleanHostname.includes("linkedin.com")) {
      return "LinkedIn";
    }

    // YouTube
    if (
      cleanHostname.includes("youtube.com") ||
      cleanHostname.includes("youtu.be")
    ) {
      return "YouTube";
    }

    // TikTok
    if (cleanHostname.includes("tiktok.com")) {
      return "TikTok";
    }

    // Reddit
    if (cleanHostname.includes("reddit.com")) {
      return "Reddit";
    }

    // Medium
    if (cleanHostname.includes("medium.com")) {
      return "Medium";
    }

    // GitHub
    if (cleanHostname.includes("github.com")) {
      return "GitHub";
    }

    // Website (generic)
    // If it's a valid URL but doesn't match any known platform, return "Website"
    return "Website";
  } catch {
    // If URL parsing fails, return "Website" as fallback
    return "Website";
  }
}
